import React, { useEffect, useState } from 'react'
import { TextField as MuiTextField, Typography } from '@material-ui/core'

import { FilterProps } from './types'

export const MultStringFilter = (props: FilterProps) => {
  const { label, defaultValue, onChange } = props
  const [value, setValue] = useState(defaultValue)

  useEffect(() => {
    if (!defaultValue) {
      setValue(defaultValue)
    }
  }, [defaultValue])

  return (
    <>
      <MuiTextField
        id={label}
        variant="standard"
        multiline
        rows={4}
        label={label}
        fullWidth
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = e.target.value.replace(/\s+$/, '').replace(/\s/g, ',')
          setValue(newValue)
          onChange(newValue, newValue)
        }}
      />
      <Typography variant="caption">enter comma separated values</Typography>
    </>
  )
}
